import { render, staticRenderFns } from "./UpdateNewAdvPassword.vue?vue&type=template&id=6b658213&"
import script from "./updateNewAdvPassword?vue&type=script&lang=js&"
export * from "./updateNewAdvPassword?vue&type=script&lang=js&"
import style0 from "./UpdateNewAdvPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports